//#region Libraries Imports
import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ActivatedRoute, Params } from '@angular/router';
import { ServicesTokenService } from '../services/services-token/services-token.service';
import { Numbers, PATTERNS, VALID_CHARS } from 'src/app/utils/constants';
//#endregion

//#region Local Imports
//#endregion

@Injectable({ providedIn: 'root' })
export class CommonService extends BehaviorSubject<any[]> {
  idCurrentForm: number = Numbers.number1;
  idCurrentFormAux: number = Numbers.number1;
  idFormParam: number = Numbers.number1;
  idFormStorage = '';
  languageSelected = 'es';
  languageSelectedAux = '';
  token = '';

  //#region Constructor
  /**
   * @description constructor
   * @params activatedRoute
   * @params stSrv
   */
  constructor(
    private activatedRoute: ActivatedRoute,
    private stSrv: ServicesTokenService
  ) {
    super([]);
    this.activatedRoute = activatedRoute;
    this.stSrv = stSrv;
    this.activatedRoute.queryParams.subscribe((params: any) => {
      if (params.id !== undefined) {
        this.idFormParam = params.id;
      } else {
        this.idFormParam = 1;
      }
      this.setForm();
    });
    this.stSrv = stSrv;
  }
  //#endregion

  //#region Methods
  /**
   * @description asigna el formulario a mostrar
   */
  setForm(): number {
    // TODO: realizar el set en la web
    // 1-Ocio; 2-Deporte; 3-Particulares; 4-LegalParticular; 5-LegalPropietario; 6-Estudiantes
    // localStorage.removeItem('idform');
    // localStorage.setItem('idform', '3');
    // TODO: realizar el set en la web - FIN

    this.idFormStorage = localStorage.getItem('idform');

    if (this.idFormStorage !== '' && this.idFormStorage !== null) {
      this.idCurrentFormAux = parseInt(this.idFormStorage, Numbers.number10);
    } else {
      this.idCurrentFormAux = this.idFormParam;
    }

    if (this.idCurrentFormAux <= Numbers.number0 || this.idCurrentFormAux > Numbers.number6) {
      this.idCurrentForm = Numbers.number1;
    } else {
      this.idCurrentForm = this.idCurrentFormAux;
    }

    return this.idCurrentForm;
  }

  /**
   * @description asigna el pattern a validar
   */
  patternsForm(key: string): RegExp {
    return PATTERNS[key] || null;
  }
  /**
   * @description Recuperar token
   */
  getToken(): Subscription {
    return this.stSrv.authToken
      .pipe(take(1)).subscribe(auth => {
        this.token = auth;
        return this.token;
      });

  }
  /**
   * @description transforma de b64 a blob
   */
  public b64toBlob(b64Data: any, contentType: any, sliceSize?: any): Blob {
    if (contentType === undefined) {
      contentType = '';
    }

    if (sliceSize === undefined) {
      sliceSize = Numbers.number512;
    }

    const byteCharacters: string = atob(b64Data.fichero);
    const byteArrays: any[] = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const sliceResult: string = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers: number[] = [sliceResult.length];
      for (let i = 0; i < sliceResult.length; i++) {
        byteNumbers[i] = sliceResult.charCodeAt(i);
      }
      byteArrays.push(new Uint8Array(byteNumbers));
    }

    return new Blob(byteArrays, { type: contentType });
  }

  /**
   * @description validar DNI
   */
  public validateDNI(dni: any): boolean {
    let returnV: boolean;
    if (dni !== '') {
      const dniRexp: RegExp = PATTERNS.dni;
      const numberD: any = dni.substr(0, dni.length - 1);
      const letter: any = dni.substr(dni.length - 1, 1);

      if (!dniRexp.test(dni)) {
        returnV = false;
      } else {
        if (!isNaN(numberD) && numberD.toString().length === Numbers.number8
          && letter.length === 1) {
          const lettersOrder = 'TRWAGMYFPDXBNJZSQVHLCKET';
          switch (lettersOrder[numberD % Numbers.number23]) {
            case (letter.toUpperCase()):
              returnV = true;
              break;
            default:
              returnV = false;
              break;
          }
        }
      }
    } else {
      returnV = true;
    }
    return returnV;
  }

  /**
   * @description validar NIF
   */
  public validateNIF(control: any): boolean {
    let returnV: boolean;
    if (control === '') {
      returnV = true;
    } else {
      const dni: any = control;
      let numero: any = dni.substr(0, dni.length - 1);
      let let2: any = dni.substr(dni.length - 1, 1);
      let2 = let2.toUpperCase();
      numero = numero % Numbers.number23;
      let letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
      letra = letra.substring(numero, numero + 1);

      if (letra !== let2) {
        returnV = false;
      } else {
        returnV = true;
      }
    }
    return returnV;
  }

  /**
   * @description validar NIE
   */
  public validateNIE(control: any): boolean {
    let returnV: boolean;
    if (control === '') {
      returnV = true;
    } else {
      const str: any = control.toString().toUpperCase();

      if (!PATTERNS.nie.test(str)) {
        returnV = false;
      } else {
        const nie: any = str
          .replace(/^[X]/, '0')
          .replace(/^[Y]/, '1')
          .replace(/^[Z]/, '2');

        const letter: any = str.substr(-1);
        const charIndex = parseInt(nie.substr(0, Numbers.number8), Numbers.number10) % Numbers.number23;

        if (VALID_CHARS.charAt(charIndex) === letter) {
          returnV = true;
        } else {
          returnV = false;
        }
      }
    }
    return returnV;
  }

  /**
   * @description validar CIF
   */
  public validateCif(cif: any): boolean {
    let result = false;
    let auxA: number;
    let auxB: number;

    cif = cif.toUpperCase();

    if (cif.match(PATTERNS.cif1) || cif.match(PATTERNS.cif2) || cif.match(PATTERNS.cif3)) {
      const control: any = cif[cif.length - 1];
      let sumA = 0;
      let sumB = 0;

      for (let i = 1; i < Numbers.number8; i++) {
        if (i % Numbers.number2 === 0) {
          sumA += parseInt(cif[i], Numbers.number10);
        } else {
          auxA = parseInt(cif[i], Numbers.number10) * Numbers.number2;
          auxB = Numbers.number0;

          if (auxA > Numbers.number9) {
            auxB = Numbers.number1 + (auxA - Numbers.number10);
          } else {
            auxB = auxA;
          }
          sumB += auxB;
        }
      }

      const sumC = sumA + sumB + '';
      const sumD = (Numbers.number10 - (parseInt(sumC[sumC.length - 1], Numbers.number10))) % Numbers.number10;

      const letters = 'JABCDEFGHI';
      if (control >= '0' && control <= '9') {
        result = (control === sumD);
      } else {
        result = ((control.toUpperCase()) === letters[sumD]);
      }
    } else {
      result = true;
    }
    return result;
  }

  /**
   * @description validar Pasaporte
   */
  public validatePassport(num: any): boolean {
    let returnV: boolean;
    if (PATTERNS.validPassport.test(num)) {
      returnV = false;
    } else {
      returnV = true;
    }
    return returnV;
  }
  /**
   * @description Retorna si la cadena es alfabetica
   * @params cadena
   */
  public isAlphabetic(cadena: any): boolean {
    let returnV: boolean;
    if (cadena.match(PATTERNS.alpha)) {
      returnV = true;
    } else {
      returnV = false;
    }
    return returnV;
  }

  //#endregion
}
